function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import { getUsdCreditBalance } from 'researcher/user/reducer';
import { getChinaLocalization } from 'shared/account/reducer';
import { ALIPAY, ALLPAGOCREDITCARD, ALLPAGOPAYPAL, BANK_TRANSFER, BOLETO, CREDITCARD, PAYPAL, UNIONPAY, WECHAT, isAllpagoPaymentMethod, paymentMethodNameOfExternalThirdPartyPaymentSite, paymentMethodRequiresBillingInformation, paymentMethodRequiresOrganization, paymentMethodRequiresPhoneNumber, paymentMethodSupportsCurrencySelection, paymentMethodSupportsFapesp, paymentMethodSupportsFapiao } from 'researcher/domain/transaction/payment-method';
import { MULTIMEDIA_GOAL } from 'researcher/order-form/order/constants';
import * as c from './constants';
export var initialState = {
  allpagoCheckoutId: null,
  braintreeMerchantAccounts: [],
  countries: [],
  currencies: [],
  fapiaoDeliveryTimelines: [],
  fapiaoTypes: [],
  formData: {
    creditCard: {
      currency: {
        value: null
      }
    },
    creditsApplied: 0,
    paymentMethodId: '',
    prepaymentApplied: 0,
    voucherApplied: null
  },
  paymentMethodId: null,
  paymentMethods: [],
  promotionalCode: null,
  receiptCode: '',
  receiptCodes: {
    payoff: null
  },
  status: {
    loading: true,
    loaded: false,
    saved: false,
    saving: false,
    saveFailed: null
  },
  userAddresses: [],
  userCountry: null,
  validVoucher: null
};
export var getAddressesOfType = createSelector(function (_ref) {
  var user = _ref.user;
  return user;
}, function (_ref2) {
  var type = _ref2.type;
  return type;
}, function (user, type) {
  return user ? user.addresses.filter(function (address) {
    return address.label.toLowerCase() === type;
  }).map(function (address) {
    var labelName = !address.name || address.name && address.organization ? address.organization : address.name;
    return {
      label: [labelName, address.address1].filter(function (x) {
        return x;
      }).join(' '),
      value: address.id,
      address: address
    };
  }) : [];
});
export var getUsdCreditsToApply = createSelector(getUsdCreditBalance, function (_ref3) {
  var total = _ref3.total;
  return total;
}, function (usdCreditsAvailable, total) {
  return Math.min(usdCreditsAvailable, total);
});
export var getFapiaoAvailable = createSelector(function (_ref4) {
  var application = _ref4.application;
  return application.config.fapiaoAvailable;
}, function (_ref5) {
  var user = _ref5.user;
  return user.country;
}, function (_ref6) {
  var application = _ref6.application;
  return application.currentLocalization.allowsFapiaoProcessingAfterPayment;
}, function (fapiaoAvailable, country, allowsFapiaoProcessingAfterPayment) {
  return fapiaoAvailable && country === 'CN' && !allowsFapiaoProcessingAfterPayment;
});
export var getFapiaoFormVisible = createSelector(getFapiaoAvailable, function (_ref7) {
  var paymentMethodId = _ref7.paymentMethodId;
  return paymentMethodId;
}, function (_ref8) {
  var requireFapiao = _ref8.requireFapiao;
  return requireFapiao;
}, function (fapiaoAvailable, paymentMethodId, requireFapiao) {
  return fapiaoAvailable && paymentMethodSupportsFapiao(paymentMethodId) && requireFapiao;
});
export var getAvailablePaymentMethods = createSelector(function (_ref9) {
  var _order$order;
  var order = _ref9.order;
  return order === null || order === void 0 || (_order$order = order.order) === null || _order$order === void 0 ? void 0 : _order$order.customerGoal;
}, function (_ref10) {
  var user = _ref10.user;
  return user.paymentMethods;
}, function (_ref11) {
  var excludePaymentMethods = _ref11.excludePaymentMethods;
  return excludePaymentMethods;
}, function (_ref12) {
  var requireFapiao = _ref12.requireFapiao;
  return requireFapiao;
}, function (_ref13) {
  var requestAllpago = _ref13.requestAllpago;
  return requestAllpago;
}, function (_ref14) {
  var usingFapespFunds = _ref14.usingFapespFunds;
  return usingFapespFunds;
}, function (customerGoal, rawPaymentMethods) {
  var excludedPaymentMethods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var requireFapiao = arguments.length > 3 ? arguments[3] : undefined;
  var requestAllpago = arguments.length > 4 ? arguments[4] : undefined;
  var usingFapespFunds = arguments.length > 5 ? arguments[5] : undefined;
  var paymentMethods = rawPaymentMethods;

  // Filter out excluded options
  if (excludedPaymentMethods.length > 0) {
    paymentMethods = paymentMethods.filter(function (paymentMethod) {
      return excludedPaymentMethods.indexOf(paymentMethod.id) === -1;
    });
  }

  // Fapiao requires specific methods
  paymentMethods = requireFapiao ? paymentMethods.filter(function (pm) {
    return paymentMethodSupportsFapiao(pm.id);
  }) : paymentMethods;

  // FAPESP also requires specific methods
  paymentMethods = usingFapespFunds ? paymentMethods.filter(function (pm) {
    return paymentMethodSupportsFapesp(pm.id);
  }) : paymentMethods;

  // Allpago methods are mutually exclusive
  paymentMethods = requestAllpago ? paymentMethods.filter(function (pm) {
    return isAllpagoPaymentMethod(pm.id);
  }) : paymentMethods.filter(function (pm) {
    return !isAllpagoPaymentMethod(pm.id);
  });

  // no bank transfer for multimedia services
  paymentMethods = (customerGoal === null || customerGoal === void 0 ? void 0 : customerGoal.name) === MULTIMEDIA_GOAL ? paymentMethods.filter(function (pm) {
    return pm.id !== BANK_TRANSFER;
  }) : paymentMethods;
  return paymentMethods;
});
var creditCardAndPaypalTypes = [ALLPAGOCREDITCARD, CREDITCARD, ALLPAGOPAYPAL, PAYPAL];
export var getInvoiceAddressAvailable = createSelector(function (_ref15) {
  var paymentMethodId = _ref15.paymentMethodId;
  return paymentMethodId;
}, function (_ref16) {
  var hideInvoiceAddress = _ref16.hideInvoiceAddress;
  return hideInvoiceAddress;
}, function (paymentMethodId, hideInvoiceAddress) {
  return creditCardAndPaypalTypes.indexOf(paymentMethodId) !== -1 && !hideInvoiceAddress;
});
var brazilianPaymentMethods = [ALLPAGOCREDITCARD, ALLPAGOPAYPAL, BOLETO];
export var getUsingBrazilianPaymentMethod = createSelector(function (_ref17) {
  var paymentMethodId = _ref17.paymentMethodId;
  return paymentMethodId;
}, function (paymentMethodId) {
  return brazilianPaymentMethods.indexOf(paymentMethodId) !== -1;
});
export var getSelectableCountries = createSelector(getUsingBrazilianPaymentMethod, function (_ref18) {
  var payment = _ref18.payment;
  return payment.countries;
}, function (brazilianPaymentMethod, countries) {
  return (brazilianPaymentMethod ? [countries.find(function (country) {
    return country.id === 32;
  })].filter(function (x) {
    return x;
  }) : countries).map(function (country) {
    return {
      label: country.name,
      value: country.id,
      states: country.states
    };
  });
});
export var getShowBankInfoToChinaUsers = createSelector(getChinaLocalization, function (_ref19) {
  var payment = _ref19.payment;
  return payment.formData.paymentMethodId;
}, function (chinaLocalization, paymentMethodId) {
  return chinaLocalization && paymentMethodId === BANK_TRANSFER;
});
var paymentMethodsRequiringName = [ALLPAGOCREDITCARD, ALIPAY, UNIONPAY, WECHAT];
export var getAddressFieldDisplaySettings = createSelector(function (_ref20) {
  var paymentMethodId = _ref20.paymentMethodId;
  return paymentMethodId;
}, function (_ref21) {
  var requireFapiao = _ref21.requireFapiao;
  return requireFapiao;
}, function (paymentMethodId, requireFapiao) {
  return {
    addressFormName: paymentMethodId === BANK_TRANSFER ? 'invoiceAddress' : 'billingAddress',
    displayOrganizationField: paymentMethodRequiresOrganization(paymentMethodId),
    displayNameField: paymentMethodsRequiringName.indexOf(paymentMethodId) !== -1,
    displayPhoneField: paymentMethodRequiresPhoneNumber(paymentMethodId) || requireFapiao,
    displayVatField: paymentMethodId === BANK_TRANSFER && !requireFapiao,
    nameField: [ALLPAGOCREDITCARD].indexOf(paymentMethodId) !== -1 ? "Cardholder's Name" : 'Customer name',
    organizationFieldDescription: [BOLETO].indexOf(paymentMethodId) !== -1 ? 'boleto-organization-name-description' : '',
    organizationFieldErrorMessage: 'Organization name is required',
    organizationFieldLabel: paymentMethodId === BANK_TRANSFER ? 'invoice-payer-name' : 'Organization name',
    type: paymentMethodId === BANK_TRANSFER ? 'invoice' : 'billing'
  };
});
export var getPaymentMethodRequiresBillingInformation = createSelector(function (_ref22) {
  var paymentMethodId = _ref22.paymentMethodId;
  return paymentMethodId;
}, function (paymentMethodId) {
  return paymentMethodRequiresBillingInformation(paymentMethodId);
});
export var getInvoiceAddressFieldDisplaySettings = createSelector(function (_ref23) {
  var paymentMethodId = _ref23.paymentMethodId;
  return paymentMethodId;
}, function (_ref24) {
  var requireFapiao = _ref24.requireFapiao;
  return requireFapiao;
}, function (paymentMethodId, requireFapiao) {
  return {
    displayOrganizationField: true,
    displayNameField: false,
    displayPhoneField: paymentMethodRequiresPhoneNumber(paymentMethodId) || requireFapiao,
    displayVatField: paymentMethodId === BANK_TRANSFER && !requireFapiao,
    organizationFieldDescription: [BOLETO].indexOf(paymentMethodId) !== -1 ? 'boleto-organization-name-description' : '',
    organizationFieldErrorMessage: 'invoice-payer-name-required',
    organizationFieldLabel: 'invoice-payer-name'
  };
});
export var getVisible = createSelector(getFapiaoAvailable, function (_ref25) {
  var fapiaoSelectionDisabled = _ref25.fapiaoSelectionDisabled;
  return fapiaoSelectionDisabled;
}, function (_ref26) {
  var fapiaoRequirementConfirmed = _ref26.fapiaoRequirementConfirmed;
  return fapiaoRequirementConfirmed;
}, function (_ref27) {
  var total = _ref27.total;
  return total;
}, function (fapiaoAvailable, fapiaoSelectionDisabled, fapiaoRequirementConfirmed, total) {
  return total > 0 && (fapiaoRequirementConfirmed !== '' || !fapiaoAvailable || fapiaoSelectionDisabled);
});
export var getPaymentMethodCurrency = createSelector(function (_ref28) {
  var payment = _ref28.payment;
  return payment.currencies;
}, function (_ref29) {
  var payment = _ref29.payment;
  return payment.formData;
}, function (currencies, formData) {
  if (!paymentMethodSupportsCurrencySelection(formData.paymentMethodId)) {
    return null;
  }
  return currencies.find(function (_ref30) {
    var isoCode = _ref30.isoCode;
    return isoCode === formData.creditCard.currency.value;
  });
});
export var getExternalThirdPartyPaymentMethodName = createSelector(function (_ref31) {
  var payment = _ref31.payment;
  return payment.formData.paymentMethodId;
}, function (paymentMethodId) {
  return paymentMethodNameOfExternalThirdPartyPaymentSite(paymentMethodId);
});
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.PAYMENT_METHOD_READY:
    case c.PAYMENT_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        loaded: true
      });
    case c.PAYMENT_METHOD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        loaded: false
      });
    case c.SAVE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        saved: false,
        saving: true
      });
    case c.SAVE_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        saved: false,
        saving: false,
        saveFailedAt: Date.now()
      });
    default:
      return state;
  }
};
export var paymentReducer = function paymentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.PAYMENT_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        braintreeMerchantAccounts: action.payment.braintreeMerchantAccounts,
        countries: action.payment.countries,
        currencies: action.payment.currencies,
        fapiaoDeliveryTimelines: action.payment.fapiaoDeliveryTimelines,
        fapiaoTypes: action.payment.fapiaoTypes,
        paymentMethods: action.payment.paymentMethods,
        promotionalCode: action.payment.promotionalCode,
        receiptCodes: action.payment.receiptCodes,
        status: status(state.status, action),
        userAddresses: action.payment.userAddresses,
        userCountry: action.payment.userCountry
      });
    case c.PAYMENT_CURRENCIES_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        currencies: action.currencies
      });
    case c.PAYMENT_METHOD_SET:
      return _objectSpread(_objectSpread({}, state), {}, {
        paymentMethodId: action.paymentMethodId
      });
    case c.PAYMENT_FORM_DATA_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        formData: {
          creditCard: action.formData.creditCard,
          creditsApplied: action.formData.creditsApplied,
          paymentMethodId: action.formData.paymentMethodId,
          prepaymentApplied: action.formData.prepaymentApplied,
          voucherApplied: action.formData.voucherApplied
        }
      });
    case c.PAYMENT_METHOD_REQUESTED:
    case c.PAYMENT_METHOD_READY:
    case c.SAVE_REQUESTED:
    case c.SAVE_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    default:
      return state;
  }
};